(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["benefit-slider"] && !window.DesignMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
    function isMobileDevice() {
        return window.innerWidth <= 768;
    }
    if (isMobileDevice()) {
        const slides = document.querySelectorAll('.trust-element');
        let currentIndex = 0;
        let timeout;

        slides.forEach((slide, index) => {
            slide.style.display = index === 0 ? 'flex' : 'none';
        });

        function updateSlides() {
            slides.forEach((slide, index) => {
                slide.style.display = index === currentIndex ? 'flex' : 'none';
            });
        }

        function goToNextSlide() {
            currentIndex = (currentIndex + 1) % slides.length;
            updateSlides();
            scheduleSlideChange();
        }

        function scheduleSlideChange() {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                requestAnimationFrame(goToNextSlide);
            }, 4000);
        }
        scheduleSlideChange();
    }
});

  } catch(e) { console.error(e); }
})();
})();
